module.exports = __webpack_public_path__ + "static/eastwood-no-comments-25ac62c484abcdf748603643ee17001c.svg";